import React from "react";
import middleware from "./middlewares/middleware";
import AddTransactionCoworker from "../component/sections/finance/coworker/AddTransaction";
import ListCustomerForPledge from "../component/sections/finance/coworker/pledge/ListCustomerForPledge";
import AllTransactionCoworker from "../component/sections/finance/coworker/AllTransaction";

const coworkerFinanceRoutes = [
  {
    path: "/finance/coworker/transaction",
    render: () => {
      return middleware(
        ["isUserLogin", "checkUserPermissions"],
        <AllTransactionCoworker />,
        "AllTransactionCoworker"
      );
    },
    exact: true,
  },
  {
    path: "/finance/coworker/add-transaction",
    render: () => {
      return middleware(
        ["isUserLogin", "checkUserPermissions"],
        <AddTransactionCoworker />,
        "AddTransactionCoworker"
      );
    },
    exact: true,
  },
  {
    path: "/finance/coworker/pledge/select-customer",
    render: () => {
      return middleware(
        ["isUserLogin", "checkUserPermissions"],
        <ListCustomerForPledge />,
        "ListCustomerForPledge"
      );
    },
    exact: true,
  },
];

export default coworkerFinanceRoutes;
